import {
  LINESHEET_GALLERY,
  PRODUCT_GALLERY,
  SHOWROOM_BRAND_WIDGET,
} from 'features/Storefront/constants'

export const getStorefrontProductIds = (storefront) => {
  const filteredRows = storefront?.rows?.filter(
    (row) =>
      row?.rowType === PRODUCT_GALLERY || row?.rowType === LINESHEET_GALLERY,
  )
  const productElements = filteredRows?.reduce(
    (acc, filteredRow) => [...acc, ...filteredRow?.elements],
    [],
  )
  const productIds = productElements?.reduce(
    (acc, el) =>
      el?.content?.productId ? [...acc, el?.content?.productId] : acc,
    [],
  )
  const collectionIds = productElements?.reduce(
    (acc, el) =>
      el?.content?.collectionId ? [...acc, el?.content?.collectionId] : acc,
    [],
  )

  return {
    collectionIds,
    productIds,
  }
}

// The brands shown by the Associated Brands widget are the ones placed on the
// profile, which are unrelated to the brands the viewer happens to be associated
// with. They have to be read from the storefront itself so that any visitor
// (retailer, connected brand or anonymous) resolves their name and image.
export const getStorefrontShowroomBrandIds = (storefront) =>
  (storefront?.rows || []).reduce(
    (acc, row) => [
      ...acc,
      ...(row?.elements || []).reduce(
        (elementAcc, element) =>
          element?.elementType === SHOWROOM_BRAND_WIDGET &&
          element?.content?.showroomBrandId
            ? [...elementAcc, element.content.showroomBrandId]
            : elementAcc,
        [],
      ),
    ],
    [],
  )

export const combineCollectionProducts = (
  productsInfo = [],
  collectionProductsVisibility = [],
) =>
  productsInfo.map((productInfo) => {
    const matchingCollection = collectionProductsVisibility.find(
      (collectionProduct) => collectionProduct.id === productInfo.id,
    )
    return {
      ...productInfo,
      collection: {
        ...matchingCollection?.collection,
        ...productInfo?.collection,
      },
    }
  })
